<!-- 机模配 -->
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/mould/adpterEquipment/page" getKey="rows" :columns="columns">
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :colon="false" :label="$t('shebeimingcheng')">
            <el-input v-model="yt.conditions.equipmentName"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t("sousuo") }}
            </el-button>
            <el-button
              @click="
                yt.clear(
                  (conditions = {
                    mouldId: $attrs.mouldEquipment.id,
                    orderBy: 'sort',
                  })
                )
              "
              >{{ $t("chongzhi") }}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1');
            setDefaultValue();
          "
          type="primary"
        >
          {{ $t("xinzeng") }}
        </el-button>
      </template>

      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">
              {{ $t("bianji") }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger" @click="yt.remove(scope.row, '/web/basic/mould/adpterEquipment/delete')">{{ $t("shanchu") }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('youxianji')">
            <yi_number_input :start.sync="yt.editObj.sort" :type="'number'"> </yi_number_input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" required>
            <yi_cross_select :component="'web_base_equipment_list'" :max="200" multiple :ids.sync="yt.editObj.equipmentIds"></yi_cross_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/basic/mould/adpterEquipment/batchCreate', beforeAdd)" type="primary">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('youxianji')">
            <yi_number_input :precision="1" :start.sync="yt.editObj.sort" :type="'number'"> </yi_number_input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')" required>
            <el-input disabled v-model="yt.editObj.equipmentName"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t("quxiao") }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/basic/mould/adpterEquipment/update')" type="primary">
            {{ $t("baocun") }}
          </el-button>
        </span>
      </template>
      <!-- 附带料-->
      <template v-if="yt.editObj.action == 'fudailiao'">
        <div class="dialog-scroller">
          <mould_product :mouldEquipment="$attrs.mouldEquipment" :mouldProduct="yt.editObj"></mould_product>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "web_base_mould_mould_equipment",
  data() {
    return {
      columns: [
        {
          label: "youxianji",
          prop: "sort",
        },
        {
          label: "shebeimingcheng",
          prop: "equipment.name",
        },
        {
          label: "caozuo",
          type: "slot",
          fixed: "right",
        },
      ],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.isShowPagination=false;
      // table列表接口请求参数
      this.yt.conditions = {
        mouldId: this.$attrs.mouldEquipment.id,
        pageSize: 99999999,
        orderId: "sort",
      };
      this.yt.get(1);
    }, 300);
  },
  methods: {
    setDefaultValue() {
      this.yt.editObj.sort = 1;
      this.yt.editObj.mouldId = this.$attrs.mouldEquipment.id;
      if (this.yt.list && this.yt.list.length > 0) {
        let equipmentIds = [];
        this.yt.list.forEach((item) => {
          equipmentIds.push(item.equipment.id);
        });
        this.yt.editObj.equipmentIds = equipmentIds;
      }
    },
    beforeAdd(params) {
      var paramsList = [];
      for (var i = 0; i < params.equipmentIds.length; i++) {
        let eq = {};
        eq.equipmentId = params.equipmentIds[i];
        eq.mouldId = params.mouldId;
        eq.sort = params.sort;
        paramsList.push(eq);
      }
      return paramsList;
    },
  },
};
</script>
